import { useEffect } from 'react';

import { useMutation } from '@tanstack/react-query';

import { apiClient } from '../utils';

export const usePostAuditLog = ({ endpoint, id }: { endpoint: string; id: string }) => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: async () =>
      apiClient.request({
        method: 'POST',
        endpoint: '/api/v1/audits',
        payload: {
          url: `/api/v1/${endpoint}/${id}`,
        },
      }),
    // onSuccess: () => {
    //   /**
    //    * TODO - Test:
    //    * 1. Invalidate the audit log query
    //    * 2. This will refetch the audit log showing the skeleton loader on the view log section twice when the page is loaded
    //    */
    //   // Thats OK view log is not for us but other users so they would know who has seen the page
    //   // queryClient.refetchQueries({ queryKey: ['AUDIT_VIEW_LOG', endpoint, id] });
    // },
  });

  useEffect(() => {
    mutateAsync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isPending };
};
